import { Component, OnInit, ViewChild, Input, ElementRef, EventEmitter } from '@angular/core';
import { generaleMethodes } from '../../shared/generaleMethodes.component';
import { DataTableConfig } from '../../utils/dataTableConfig';
import { DataTableDirective } from "angular-datatables";
import { Statique } from '../../utils/statique';
import { SharedModule } from '../../shared/module/shared.module';
import { DataTablesModule } from 'angular-datatables';



@Component({
	selector: 'dock-management.component',
	templateUrl: './dock-management.component.html',
	styleUrls: ['./dock-management.component.css']
})
export class dockManagement implements OnInit {
    
        dataTableConfig: DataTableConfig = new DataTableConfig();
        @ViewChild(DataTableDirective) dtElement: DataTableDirective;
        ngOnInit() {
        
        }
        
}



// WEBPACK FOOTER //
// ./src/app/component/dock-management/dock-management.component.ts